// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_3stV5qz81I3Tkzh6fj8Sed"};